import {
  Box,
  Button,
  DialogBackdrop,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogPositioner,
  DialogRoot,
  Flex,
  Image,
  Text,
} from '@chakra-ui/react';
import { useMemo } from 'react';
import type { GmoCredit } from '~/types/resources/gmo_credit';

type Props = {
  credit: GmoCredit;
  isOpen: boolean;
  onClose: () => void;
  handleDelete: () => void;
};

export const DeleteCreditModal: React.FC<Props> = (props: Props) => {
  const expire_string: string = useMemo(() => {
    const str = props.credit.expire;
    const year_and_month = str.match(/.{2}/g);
    if (year_and_month == null) return '';
    return `${year_and_month[0]}/${year_and_month[1]}`;
  }, [props.credit]);

  return (
    <DialogRoot
      open={props.isOpen}
      initialFocusEl={() => null}
      onInteractOutside={props.onClose}
    >
      <DialogPositioner>
        <DialogBackdrop />
        <DialogContent mx="32px" my={0} alignSelf="center">
          <DialogHeader pt="8px" pb="0" px="8px">
            <Flex flexDir="row" w="full" justify="right" align="end">
              <Image
                src="/assets/icon/close.svg"
                alt="icon"
                h="28px"
                w="28px"
                onClick={props.onClose}
              />
            </Flex>
          </DialogHeader>
          <DialogBody py={0}>
            <Flex
              border="1px"
              borderStyle="solid"
              borderRadius="10px"
              py="16px"
              flexDir="row"
              justifyContent="center"
              w="full"
            >
              <Box w="16px" />
              <Flex flexDir="column" justify="left" flex={1}>
                <Text fontSize="12px" lineHeight="16px" color="desc">
                  カード番号
                </Text>
                <Box h="8px" />
                <Text fontSize="15px" lineHeight="20px" letterSpacing="2px">
                  {props.credit.cardNo}
                </Text>
              </Flex>
              <Box w="8px" />
              <Flex flexDir="column" justify="left" flex={1}>
                <Text fontSize="12px" lineHeight="16px" color="desc">
                  有効期限（年/月）
                </Text>
                <Box h="8px" />
                <Text fontSize="15px" lineHeight="20px" letterSpacing="2px">
                  {expire_string}
                </Text>
              </Flex>
              <Box w="16px" />
            </Flex>
            <Box h="16px" />
            <Text fontSize="13px" fontWeight="bold" textAlign="center">
              このカードを削除しますか？
            </Text>
            <Box h="16px" />
            <Flex flexDir="row" justify="center" w="full">
              <Flex flex={1}>
                <Button
                  h="32px"
                  w="full"
                  bgColor="red"
                  colorPalette="white"
                  _focus={{
                    bgColor: 'blue',
                  }}
                  _active={{
                    bgColor: 'yellow',
                  }}
                  onClick={() => {
                    props.handleDelete();
                  }}
                >
                  削除する
                </Button>
              </Flex>
              <Box w="16px" />
              <Flex flex={1}>
                <Button
                  h="32px"
                  w="full"
                  borderWidth="1px"
                  borderColor="main"
                  bgColor="white"
                  color="main"
                  onClick={props.onClose}
                >
                  キャンセル
                </Button>
              </Flex>
            </Flex>
            <Box h="32px" />
          </DialogBody>
        </DialogContent>
      </DialogPositioner>
    </DialogRoot>
  );
};
